import HERO_IMAGE from '@/assets/images/projects/the-obsidian.webp';

export const HERO_CONTENT = {
  eyebrow: 'Est. 2008 — Dhaka, Bangladesh',
  headline: {
    first: 'Architecting',
    second: 'Tomorrow',
  },
  descriptor:
    'Defining the skyline with unyielding integrity and sophisticated design. Crafting the future of high-end real estate.',
  stats: [
    { num: '48', label: 'Projects' },
    { num: '16', label: 'Years' },
    { num: '3.2M', label: 'Sq. Feet' },
  ],
  location: 'Dhaka Central — Tower IV',
  image: HERO_IMAGE,
};

export const TRUST_STATS = [
  { value: '16+', label: 'Years of Excellence' },
  { value: '48+', label: 'Landmark Projects' },
  { value: '500+', label: 'Families Served' },
  { value: 'RAJUK', label: 'Certified Developer' },
];
